import { motion } from 'framer-motion';

const SUBJECT_COLORS = {
  Mathematics: '#448AFF', Maths: '#448AFF',
  Science: '#66BB6A', 'Environmental Studies': '#66BB6A', EVS: '#66BB6A',
  Physics: '#66BB6A', Chemistry: '#66BB6A', Biology: '#66BB6A',
  'Physical Science': '#66BB6A',
  English: '#AB47BC',
  Hindi: '#FF6B6B', Telugu: '#FF6B6B', 'Telugu (Second Language)': '#FF6B6B',
  History: '#E6A800', 'Social Studies': '#E6A800', 'Social Science': '#E6A800',
  Civics: '#E6A800', Geography: '#E6A800', 'History and Civics': '#E6A800',
  'Artificial Intelligence': '#448AFF',
};

function getAccentColor(subject) {
  return SUBJECT_COLORS[subject] || '#448AFF';
}

const ROTATIONS = [-0.5, 0.3, -0.3];

export default function DreamCard({ dream, index, onExplore, isExplored, petName }) {
  const accent = isExplored ? '#66BB6A' : getAccentColor(dream.subject);
  const displayHook = (dream.dream_hook || '').replace(/\biki\b/gi, petName || 'Your pet');

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.15, type: 'spring', stiffness: 300, damping: 25 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => !isExplored && onExplore(dream)}
      role="button"
      tabIndex={0}
      aria-label={`Explore dream about ${dream.topic || dream.subject}`}
      onKeyDown={(e) => { if (e.key === 'Enter' && !isExplored) onExplore(dream); }}
      style={{
        background: '#FFFFFF',
        border: '1.5px dashed #CCCCCC',
        borderLeft: `3px solid ${accent}`,
        borderRadius: 4,
        padding: 16,
        cursor: isExplored ? 'default' : 'pointer',
        opacity: isExplored ? 0.7 : 1,
        position: 'relative',
        transform: `rotate(${ROTATIONS[index % 3]}deg)`,
        boxShadow: 'none',
      }}
    >
      {/* Subject pill — top right */}
      <span style={{
        position: 'absolute', top: 10, right: 10,
        fontSize: 14, fontFamily: "'Patrick Hand', cursive",
        padding: '4px 12px', borderRadius: 14,
        border: `1px dashed ${accent}`,
        color: accent, background: 'transparent',
        lineHeight: 1,
      }}>
        {dream.subject}
      </span>

      {/* Emoji */}
      <span style={{ fontSize: 28, display: 'block', marginBottom: 4 }}>
        {dream.emoji}
      </span>

      {/* Dream hook */}
      <p style={{
        fontSize: 16, fontFamily: "'Patrick Hand', cursive",
        color: '#1A1A2E', lineHeight: 1.5,
        margin: '8px 0 14px', paddingRight: 60,
      }}>
        {displayHook}
      </p>

      {/* Explore button */}
      <button
        onClick={(e) => { e.stopPropagation(); if (!isExplored) onExplore(dream); }}
        disabled={isExplored}
        style={{
          fontSize: 14, fontFamily: "'Patrick Hand', cursive",
          padding: '8px 16px', borderRadius: 20,
          border: 'none',
          background: isExplored ? '#66BB6A' : accent,
          color: '#FFFFFF',
          cursor: isExplored ? 'default' : 'pointer',
          minHeight: 40, minWidth: 48,
        }}
      >
        {isExplored ? 'Explored!' : 'Explore this dream'}
      </button>
    </motion.div>
  );
}
